import React, { useState } from 'react'
import { useEffect } from 'react'
import { connectStore } from 'redux-box';
import { module as story } from 'store/story'
import { module as ui } from 'store/ui'
import {
    AlignContentHorizontal, CardIcon
} from "static/styled/custom.styled";

import Select from 'react-select'
import './stories_sync.css'
import { ThemeButton } from '../../../static/styled/custom.styled';

let platformsList = [
    {
        label: 'CMS',
        value: 'CMS'
    },
    {
        label: 'CBSE',
        value: 'CBSE'
    },
    {
        label: 'Hello',
        value: 'Hello'
    },
]
const customStyles = {
    menu: (provided, state) => ({
        ...provided,
        position: "absolute",
    }),
    control: (provide) => ({
        ...provide,
        width: "95%",
        margin: "0 auto",
        border: "none",
        boxShadow: "none",
    }),
};

const StoriesSyncModal = ({ story, ui }) => {

    const [platforms, setPlatforms] = useState([])
    const [selectedStories, setSelectedStories] = useState(story.sync_stories_list.map((str) => str.id))

    const handleCardClicked = (story) => {
        if (selectedStories.includes(story.id)) {
            setSelectedStories(prev => prev.filter((data) => data !== story.id))
        } else {
            setSelectedStories(prev => [...prev, story.id])
        }
    }

    const handleSyncNow = () => {
        let payload = {
            platforms: platforms.map((plt) => plt.value),
            story_ids: selectedStories
        }
        story.syncStoriesToOtherPlatforms(payload)
        ui.hideModal()
    }

    const isChecked = (id) => selectedStories.some((item) => item === id);
    // console.log(selectedStories)
    return (
        <div className='stories_sync_modal'>
            <p className='stories_sync_modal_header'>Sync stories to other platforms</p>
            <div className="table-container">
                <table className="info-table">
                    <thead>
                        <tr className='stories_sync_table_header_row'>
                            <th>Action</th>
                            <th>Name</th>
                            <th>Grade Levels</th>
                            <th>Source</th>
                            <th>Content Type</th>
                        </tr>
                    </thead>
                    <tbody>
                        {story.sync_stories_list && story.sync_stories_list.length > 0 ?
                            story.sync_stories_list.map((story, index) => {
                                // console.log(story)
                                console.log('Checked?', story.id, isChecked(story.id), selectedStories);
                                return (
                                    <tr key={story.id}>
                                        <td>
                                            <input type="checkbox" checked={isChecked(story.id)}
                                                onChange={() => handleCardClicked(story)} />
                                        </td>
                                        <td>{story.name}</td>
                                        <td>{story.grade_level && story.grade_level.length > 0 && story.grade_level.join(', ')}</td>
                                        <td>{story.source}</td>
                                        <td>{story.section_data && story.section_data.length > 0 && story.section_data[0].content_type}</td>
                                    </tr>
                                )
                            })
                            :
                            <tr> No stories added to sync.</tr>
                        }
                    </tbody>
                </table>
            </div>

            <div className="platforms_list_container">
                <p className="platforms_list_title">
                    Select Platforms
                </p>

                <Select
                    className="dropdown-container stories_sync_platform_select"
                    value={platforms}
                    onChange={(selectedSection) =>
                        setPlatforms(selectedSection)
                    }
                    options={platformsList}
                    placeholder="Select Platforms"
                    styles={customStyles}
                    menuPlacement="auto" // auto, top, or bottom
                    menuPosition="fixed"
                    isMulti={true}
                />
            </div>

            <ThemeButton primary onClick={handleSyncNow}>
                Sync Now
            </ThemeButton>
        </div>
    )
}

export default connectStore({
    story, ui
})(StoriesSyncModal)